import { render, staticRenderFns } from "./leaveModal.vue?vue&type=template&id=1b479f9c&"
import script from "./leaveModal.vue?vue&type=script&lang=js&"
export * from "./leaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports